export default {
  appTitle: 'LoanKnow',
  apiUrl: 'https://api.go.uff.pro/api',
  appEnv: 'production',
  useMockServices: false,
  p2enabled: false,
};
